import script from "./PortalAnalyticsPieCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalAnalyticsPieCard.vue?vue&type=script&setup=true&lang=js"

import "./PortalAnalyticsPieCard.vue?vue&type=style&index=0&id=4e21f77c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e21f77c"]])

export default __exports__